import { useRootStore } from '@/contexts/root-store-context'
import { useObservableValue } from '@/hooks/rx-hooks'
import { SessionOptions } from '@/features/iam/auth/SessionOptions'

/**
 * Convenience hook for accessing session options.
 */
export function useSessionOptions() {
  const {
    shell: { sessionOptions$ },
  } = useRootStore()

  return useObservableValue(sessionOptions$, {
    initial: SessionOptions.default,
  })
}
